// extracted by mini-css-extract-plugin
module.exports = {"CompanyAddress":"index-module_CompanyAddress_7XDtc"};